<template>
  <div id="app">
    <!-- 路由对应组件的显示 -->
    <router-view></router-view>
  </div>
</template>

<script>



export default {
  name: "App",

  watch: {
    $route: function (to, from) {

      // 是否为PC项目
      if (to.path.indexOf("pc") !== -1) {
        document.querySelector("body").setAttribute("device", "desktop");
      }
      if (to.query.invite_code) {
        localStorage.setItem("inviteCode", to.query.invite_code);
      }
      if (to.path !== "/") {
        this.$router.replace({ path: to.fullPath });
      } else {
        this.$router.replace("/pc/home");
      }
    },
  },
  created() {
    this.$store.commit("user/SET_IS_HOLIDAY", true);
  },
};
</script>

<style>
body {
  margin: 0px;
  height: 100%;
  background: #f5f5fa;
}

#app {
  font-family: Alibaba-PuHuiTi-R;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}

#app>div {
  /*height: 100%;*/
  width: 100%;
}

.ivu-message {
  z-index: 99999 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue